<script>
    export default {
        props:{
            visible: Boolean,
            half: Boolean
        },
        data() {
            return {
                isVisible: false
            }
        },
        mounted() {
            this.isVisible = this.visible;
        },
        watch: {
            visible(val) {
                this.toggle(val);
            }
        },
        methods: {
            toggle(show) {
                if(typeof show === "undefined") {
                    show = !this.isVisible;
                }

                if(show) {
                    this.show();
                } else {
                    this.hide();
                }
            },
            show() {
                this.isVisible = true;
                this.$emit('input', this.isVisible);
            },
            hide() {
                this.isVisible = false;
                this.$emit('input', this.isVisible);
            }
        }
    }
</script>

<template>
    <div class="lds-ring" :class="{ visible: isVisible, half: half }"><div></div><div></div><div></div><div></div></div>
</template>

<style lang="less" scoped>
    @import "~less-variables";

    .lds-ring {
        position: relative;
        width: 64px;
        height: 64px;
        display: none;

        &.visible {
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
        }

        div {
            box-sizing: border-box;
            display: block;
            position: absolute;
            width: 51px;
            height: 51px;
            border: 6px solid @frontier-gray-xdark;
            border-radius: 50%;
            animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
            border-color: @frontier-gray-xdark transparent transparent transparent;

            @media @IE11 {
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                margin: auto;
            }

            &:nth-child(1) {
                animation-delay: -0.45s;
            }

            &:nth-child(2) {
                animation-delay: -0.3s;
            }

            &:nth-child(3) {
                animation-delay: -0.15s;
            }
        }

        

        &.half div {
            width: 25px;
            height: 25px;
        }
    }
    
    @keyframes lds-ring {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    }
</style>